module.exports = __webpack_public_path__ + "img/SM.4bea208b.png";